// extracted by mini-css-extract-plugin
export default {"institutionIdCell":"InstitutionIdCell_institutionIdCell__jCsDv"};